import { ImageProps } from 'next/image'
import { FC, ReactNode } from 'react'

import * as SC from './styled'

export type PushPWATutoSectionProps = {
  className?: string
  image?: ImageProps
  tuto?: ReactNode
  onClose?: () => void
}

const PushPWATutoSection: FC<PushPWATutoSectionProps> = (props) => {
  const { className, image, tuto, onClose } = props

  return (
    <SC.Container className={className}>
      {image && (
        <SC.ImageWrapper>
          <SC.StyledImage {...image} />
        </SC.ImageWrapper>
      )}
      {tuto && <SC.Tuto>{tuto}</SC.Tuto>}
      {onClose && (
        <SC.CloseButtonWrapper onClick={onClose}>
          <SC.CloseButton icon="close" />
        </SC.CloseButtonWrapper>
      )}
    </SC.Container>
  )
}

export default PushPWATutoSection
